import axios from '@dap/shared-utils/http.js';

export default {
    // 查询批量表单的设置，目前只有是否走组合推荐
    getBatchRecommendedCheck (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/batch/get_batch_setting', {
            params,
        });
    },
    // 判断广点通批量仅生成推荐组合
    getRecommendedCheck (params = {}) {
        return axios.get('/dapper/api/gdt_ad/recommend/check', { params });
    },
    // 获取广点通推荐定向列表
    getRecommendedList (params = {}) {
        return axios.get('/dapper/api/gdt_ad/recommend/audiences', { params });
    },

    getCurrentAudienceScene (params = {}) {
        return axios.get('/dapper/api/gdt_ad/recommend/audiences/current', {
            params,
        });
    },
    getCurrentCreativeScene (params = {}) {
        return axios.get('/dapper/api/gdt_ad/recommend/creatives/current', {
            params,
        });
    },
    // 获取广点通推荐创意列表
    getRecommendedCreativeList (params = {}) {
        return axios.get('/dapper/api/gdt_ad/recommend/creatives', { params });
    },
    // old 复用 头条
    getGdtAudiences (params = {}) {
        return axios.get('/dapper/api/aud/audiences', { params });
    },

    getGdtDict () {
        return axios.get('/dapper/api/gdt_ad/dict');
    },

    getAutoName (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.get(`/dapper/api/gdt_ad2/${typeMap.get(type)}/auto_name`, {
            params,
        });
    },

    // 新增/修改 广告计划/广告组/广告
    update (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.post(`/dapper/api/gdt_ad2/${typeMap.get(type)}/add`, params);
    },

    // 层级搜索 广告计划/广告组
    searchCampaignGroup (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/search', { params });
    },

    // 获取详情信息 广告计划/广告组/广告
    getInfo (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.get(`/dapper/api/gdt_ad/${typeMap.get(type)}/edit`, {
            params,
        });
    },

    // 保存本次创建
    createLastData (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/batch/create_last_batch', params);
    },

    // 获取上次创建内容
    getLastData (params) {
        return axios.get('/dapper/api/gdt_ad2/batch/get_last_batch_detail', {
            params,
        });
    },

    getAppPackagesList (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/packages', { params });
    },

    getGdtTargetingDetail (params = {}) {
        return axios.get('/dapper/api/gdt_ad/targeting/detail', { params });
    },

    getGdtOrienteeringDetail (params = {}) {
        return axios.get('/dapper/api/gdt_ad/targeting/part/detail', {
            params,
        });
    },

    // api/gdt_ad/estimation
    getGdtAdEstimation (params = {}) {
        return axios.get('/dapper/api/gdt_ad/estimation', { params });
    },

    getCommon (params = {}) {
        return axios.get('/dapper/api/ad/common', { params });
    },

    postBatchData (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/batch/create_batch', params);
    },

    getBatchPreviewList (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/batch/batch_list', { params });
    },

    getAdgroupCreativePreView (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/batch/adgroup_creative_preview', {
            params,
        });
    },

    updateAdgroup (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/batch/batch_adgroup', params);
    },

    updateCampaign (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/batch/batch_campaign', params);
    },

    getBatchCreativePreView (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/batch/batch_creative_preview', {
            params,
        });
    },

    getBatchCommitBatch (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/batch/commit_batch', params);
    },

    getGdtAdSites (params = {}) {
        return axios.get('/dapper/api/gdt_ad/sites', { params });
    },

    getGdtWechatSites (params = {}) {
        return axios.get('/dapper/api/gdt_ad/wechat_sites', { params });
    },

    getGdtProfiles (params = {}) {
        return axios.get('/dapper/api/gdt_ad/profiles', { params });
    },

    gdtGdtAdCreativeList (params) {
        return axios.get('/dapper/api/gdt_ad/creative/list', { params });
    },

    checkGdtName (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/gdt_ad/${typeMap.get(type)}/checkname`, {
            params,
        });
    },

    getAdDetailData (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/gdt_ad2/duplicate/get_${typeMap.get(type)}_detail`, { params });
    },

    saveCopyOrPushData (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.post(`/dapper/api/gdt_ad2/duplicate/save_${typeMap.get(type)}_detail`, params);
    },

    commitCopyOrPush (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/duplicate/commit_duplicate_batch', params);
    },

    getAdCopyOrPushBatchId (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.post(`/dapper/api/gdt_ad2/duplicate/create_batch_from_${typeMap.get(type)}`, params);
    },

    getAdCopyOrPushList (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/duplicate/duplicate_batch_list', {
            params,
        });
    },

    addPackages (params = {}) {
        return axios.post('/dapper/api/gdt_ad2/packages', params);
    },

    getGdtTableList (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/gdt_ad/${typeMap.get(type)}/list`, {
            params,
        });
    },

    getCrowdsList (params) {
        return axios.get('/dapper/api/gdt_ad2/crowds', { params });
    },

    getLabels (params) {
        return axios.get('/dapper/api/gdt_ad/labels', { params });
    },

    getGdtDefaultAccount (params = {}) {
        return axios.get('/dapper/api/gdt_ad/default_account', { params });
    },

    addGdtProfile (params = {}) {
        return axios.post('/dapper/api/gdt_ad/dap_profiles', params);
    },

    getGdtProfileList (params = {}) {
        return axios.get('/dapper/api/gdt_ad/dap_profiles', { params });
    },

    deleteGdtProfile (params = {}) {
        return axios.put('/dapper/api/gdt_ad/dap_profiles', params);
    },

    getRtaTargetListData (params = {}) {
        return axios.get('/api/rta/v1/strategy/target/list', { params });
    },

    getRtaVersionListData (params = {}) {
        return axios.get('/api/rta/v1/strategy/version/list', { params });
    },
    // 绑定检查接口
    getRtaBindStatus (params = {}) {
        return axios.post(
            '/api/rta/v1/target/bind/save',
            {
                ...params,
                dry_run: true,
            },
            {
                headers: { 'Content-Type': 'application/json' },
            }
        );
    },
    getDraftCheck (params = {}, type = 'audience') {
        return axios.get(`/dapper/api/gdt_ad2/batch/${type}_draft_check`, {
            params,
        });
    },
    getDraftList (params = {}, type = 'audience') {
        return axios.get(`/dapper/api/gdt_ad2/batch/${type}_draft`, { params });
    },
    createDraft (params = {}, type = 'audience') {
        return axios.post(`/dapper/api/gdt_ad2/batch/${type}_draft`, params);
    },
    getDraftData (params = {}, type = 'audience') {
        return axios.get(`/dapper/api/gdt_ad2/batch/${type}_draft_data`, {
            params,
        });
    },
    putDraft (params = {}, type = 'audience') {
        return axios.put(`/dapper/api/gdt_ad2/batch/${type}_draft`, params);
    },
    getConversionList: (params) => axios.get('/dapper/api/gdt_ad/convert', { params }),

    // 获取数据源 2022/02/27
    getDataSourceList: (params) => axios.get('/dapper/api/gdt_ad/user_action_set', { params }),
    // 创建转化
    addGdtConvert: (params) => axios.post('/dapper/api/gdt_ad/convert', params),
    getWeChatChannel (params = {}) {
        return axios.get('/dapper/api/gdt_ad2/wechat_channel/list', { params });
    },
};
